import { PROJECTS_QUERY_KEY } from "../projects";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Clients from "core/api-clients";
import { IUpdateAudienceRequestModel } from "@lib/types";

export function useUpdateAudience(
  accountNumber: number,
  projectId: number,
  contextId: string,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (requestModel: IUpdateAudienceRequestModel) =>
      await Clients.ManagementBackend.Audiences.put(
        accountNumber,
        projectId,
        contextId,
        requestModel,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROJECTS_QUERY_KEY.GET] });
    },
  });
}
